<template>
  <div class="zhihuwenda-mian">
    <img class="wx-headerTimg"/>
    <div class="zhihubg">
      <span class="titlevalue">日历无法连接Wi-Fi？</span>
      <img class="wx-redTimg" src="../../../static/img/bg_red.png" />
      <span class="headertitle">辛苦您按以下方式</span>
      <span class="headertitle1">完成配网</span>
      <div>
        <span class="wx-titletimg">
        <img  src="../../../static/img/bg_bt.png" />
        <p class="ansTitle">步骤一</p>
      </span>
      </div>
      <p class="content">您可以使用APP对您的日历进行配网了，APP下载地址：</p>
      <p class="content">a）安卓手机下载，点击“复制链接”，粘贴到手机系统浏览器打开即可</p>
      <button class="titBtn" ref="copy" :data-clipboard-text="this.apkUrl" @click="copy" id="copy_text" >
        <img class="iconDown"  src="../../../static/img/anzhuo_huaban@3x.png"/>
        <span class="downtext">复制链接</span>
      </button>
      <p class="content">b）iOS手机下载</p>
      <button class="titBtn" @click="goiOS()">
        <img class="iconDown"  src="../../../static/img/pingguo@3x.png"/>
        <span class="downtext">苹果手机下载</span>
      </button>
      <div>
        <span class="wx-titletimg">
        <img  src="../../../static/img/bg_bt.png" />
        <p class="ansTitle">步骤二</p>
      </span>
      </div>
      <p class="content">a）手机连接2.4GWi-Fi。如果您使用的安卓手机，APP会提示您当前使用的是否是2.4G网络；</p>
      <p class="content">b）APP上先输入密码，点“确认”；</p>
      <p class="content">c）长按日历的左键；</p>
<!--      <p class="content">d）APP上点“确认”</p>-->
      <div>
        <span class="wx-titletimg">
        <img  src="../../../static/img/bg_bt.png" />
        <p class="ansTitle">步骤三</p>
      </span>
      </div>
      <p class="content">APP配网选广播还是组播？</p>
      <p class="acscontent">大部分路由器都支持广播，如果您尝试了两三次依然不能成功，可能是您的路由器不支持广播。可以选择组播方式。如果还不成功请联系我们的客服人员。</p>
    </div>
<!--    <div class="toast" v-show="toastShow">-->
<!--      {{toastText}}-->
<!--    </div>-->
  </div>
</template>

<script>

// import Common from '../../assets/js/common.js'
// import wx from 'weixin-js-sdk'
// import { Calendar } from "vant";
// import { Cell } from "vant";
// var isLocal = Common.getEvn()
// var _local = window.location.href
// var api = process.env.BASE_URL
import Clipboard from 'clipboard'
export default {
  data () {
    return {
      myLayout: 'wx-timg',
      apkUrl: 'https://cnbj2.fds.api.xiaomi.com/common/max/prod/APK/esptouch.apk',
      appName: 'Espressif Esptouch',
      toastShow: false,
      toastText: '',
      imageurlContent: 'http://www.miaomiaoce.com/mydevice/max/test/zh_qa/bg%402x.png'
    }
  },
  methods: {
    toast (str) {
      let v = this
      v.toastText = str
      v.toastShow = true
      setTimeout(function () {
        v.toastShow = false
      }, 1500)
    },
    banFontSize () {
      // eslint-disable-next-line no-undef
      if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize)
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
        }
      }
      function handleFontSize () {
        // 设置网页字体为默认大小
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
        // 重写设置网页字体大小的事件
        // eslint-disable-next-line no-undef
        WeixinJSBridge.on('menu:setfont', function () {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
        })
      }
    },
    goAndroid () {
      // window.location.replace('https://cnbj2.fds.api.xiaomi.com/common/max/prod/APK/esptouch.apk')
      window.location.replace('https://cnbj2.fds.api.xiaomi.com/common/max/prod/APK/esptouch.apk')
    },
    goiOS () {
      window.location.replace('https://apps.apple.com/cn/app/espressif-esptouch/id1071176700')
    },
    copy: function () {
      // eslint-disable-next-line no-unused-vars
      var _this = this
      // eslint-disable-next-line no-undef
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', e => {
        alert('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      this.toastShow = false
      clipboard.on('error', e => {
        // 不支持复制
        this.toastShow = true
        // eslint-disable-next-line no-undef
        this.toast('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
        this.toastShow = false
      })
    }
  },
  created () {
    this.banFontSize()
  }
}
</script>
<style lang="stylus" scoped>
.zhihuwenda-mian {
   margin-top: -60px;
   /*padding: 0px 0px;*/
  /*display: flex;*/
  //flex-wrap: wrap;
  //justify-content: space-between;
  //align-items: center;
  background-color: #4E4390;
  /* background: -webkit-linear-gradient(bottom,rgba(0, 0, 0, 0.6),#4E4390); */
  // margin-left: -10px;
  // margin-right: -10px;
  /*margin-bottom: 40px;*/
}

.zhihubg {
  // margin-top: 158px;
  padding: 0 5px;
  display: flex;
  flex-flow: column;
  margin-top: -2vh;
  align-items: flex-start;
  background-color: #FFFFFF;
  margin-left: 7.5px;
  margin-right: 7.5px;
  margin-bottom: 20px;
  border-radius: 8px;
}

p:first-child {
  background: #000000;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 12px;
}
.wx-time {
  background: #000000;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 4px;
}

.value {
  font-size: 14px;
  color: #666666;
  margin-bottom: 4px;
}

.headertitle {
  font-size: 14px;
  color: #FFFFFF;
  align-self: center;
  margin-top: -60px;
}

.headertitle1 {
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 20px;
  align-self: center;
}

.titlevalue {
  font-size: 22px;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: -118px;
  align-self: center;
}

.titlebg {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.titleDetail {
  font-size: 12px;
  color: #FFFFFF;
  text-align: left;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 15px;
}

.buzhou5 {
  font-size: 12px;
  color: #53479A;
  background-color: #FFFFFF;
  height: 17px;
  width: 50px;
  margin-top: 17px;
}

.wx-timg {
  /*margin-top: 1px;*/
  width: 100%;
  height: 100%;
}

.wx-titletimg {
  margin-top: 35px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wx-headerTimg {
  /*width: 100%;*/
  height: 200px;
  /*border: none;*/
}

.wx-redTimg {
  align-self: center;
  height: 69px;
  width: 178;
  margin-top: 1vh;
}

.wx-footerTimg {
  width: 100%;
  height: 90px;
}

.wx-fimg {
  display: none;
  /*display: block;*/
}

.wx-img {
  margin-top: 1px;
  margin-bottom: -5px;
  width: 22px;
  height: 22px;
}

.valueContent {
  margin-top: 1px;
  font-size: 16px;
  color: #666666;
  margin-bottom: 4px;
}

.content {
  text-align: left;
  font-size: 14px;
  color: #333333;
  margin-top: 3px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 4px;
}

.downtext {
  font-size: 14px;
  color: #FFFFFF;
  margin-left: 5px;
}

.acscontent {
  text-align: left;
  font-size: 14px;
  color: #333333;
  margin-top: 5px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
}

.fzcontent {
  text-align: left;
  font-size: 14px;
  color: #333333;
  margin-top: -1px;
  margin-left: 36px;
  margin-right: 15px;
  margin-bottom: 4px;
}

.ansTitle {
  font-size: 14px;
  color: #FFFFFF;
  margin-left: -55px;
}

.detailTitle {
  font-size: 14px;
  color: #333333;
  margin-left: -55px;
}

.answercontent {
  margin-top: 3px;
  text-align: left;
  font-size: 16px;
  color: #333333;
  margin-bottom: 14px;
}

.titBtn {
    font-size: 14px;
    color: #FFFFFF;
    /* margin-top: 5px; */
    margin-left: 3.5vw;
    /* border-width: 0; */
    background-color: #4E4390;
    height: 44px;
    width: 90vw;
    border-radius: 22px;
    /* margin-right: 10px; */
    flex-direction: row;
    text-align: left;
    margin-bottom: 5px;
    align-items: center;
    justify-content: center;
    display: flex;
    /* flex-flow: column; */
    /* padding-bottom: 17px; */
}
.fzBtn {
  font-size: 12px;
    color: #1177EC;
    margin-top: -20px;
    margin-left: 111px;
    width: 40px;
    height: 20px;
    /* margin-right: 10px; */
    text-align: left;
}
.fz2Btn {
  font-size: 12px;
    color: #1177EC;
    margin-left: 322px;
    margin-top: -24px;
    /* margin-right: 10px; */
    width: 40px;
    height: 20px;
    text-align: left;
}

.iconDown {
    width: 19px;
    height: 23px;
}

.toast {
            /*position: fixed;*/
            z-index: 2000;
            left: 50%;
            top:60%;
            transition:all .5s;
            -webkit-transform: translateX(-50%) translateY(-50%);
               -moz-transform: translateX(-50%) translateY(-50%);
                -ms-transform: translateX(-50%) translateY(-50%);
                 -o-transform: translateX(-50%) translateY(-50%);
                    transform: translateX(-50%) translateY(-50%);
            text-align: center;
            border-radius: 5px;
            color:#FFF;
            /* background: rgba(17, 17, 17, 0.7); */
            background: #4E4390;
            height: 100px;
            line-height: 45px;
            padding: 0 15px;
        }

</style>



// WEBPACK FOOTER //
// src/pages/UpgradeVersionInstructions/UpgradeVersionInstructions3.vue